var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
// import * as FontAwesome from 'react-icons/lib/fa'
// import FontAwesome from 'react-icons/lib/fa';

var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle
} = ReactNative;

var Icon = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      color:'black',
      style:{},
      name:'pencil',
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    var {style, name, color, ...otherProps} = this.props;
    if( name == 'credit-pay' ) name = "money";
    if( name == 'times' ) name = "times-circle";
    if( name == "pay-shortcut" ) name = "money";
    if( name == "usd" ) name = "money";
    if( name == "users" ) name = "user-plus";
    if( typeof style.color !== 'undefined' && this.props.color == 'black' ) color = style.color;
    var TheClass = require('react-icons/lib/fa/'+name);
    return <View style={[style]}>
      <TheClass style={{alignSelf:'center'}} color={color} {...otherProps} />
    </View>;
    // return <FontAwesome name="pencil" />
    // return <MdIcon name="edit" />
    // return <FontAwesome {...this.props} />
  }
});

module.exports = Icon;



// WEBPACK FOOTER //
// ./src/wrappers/ReUpIcon.js